import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {QuickTip, FormLayout, RadioButtonGroup, RadioButton, Panel} from 'components';
import {FormattedMessage} from 'react-intl';

const TaxableOnPayoutForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;
  if (!currentCoverage.isDisabilityCoverage) return null;

  return (
    <div>
      <Panel.Separator/>
      <Panel.Subheader title={t('taxable_benefits.Disability Claims')} />
      <FormLayout>
        <RadioButtonGroup name='taxable_on_payout'
          selectedValue={currentCoverage.taxableOnPayout}
          onChange={(name, value) => currentCoverage.merge({taxableOnPayout: value})}
          label='taxable_benefits.Taxable on Payout'
          errorMessage={errors.taxableOnPayout}> 
          <RadioButton value={true} className='pt1 pr2'>{t('Yes')}</RadioButton>
          <RadioButton value={false} className='pt1'>{t('No')}</RadioButton>
        </RadioButtonGroup>
        <QuickTip trait='caution'
          paragraphs={[
            currentCoverage.taxableOnPayout ? 
            <FormattedMessage id='taxable_benefits.help_text.taxable_on_payout.yes' values={{yes: <b>{t('Yes')}</b>}}/> :
              <FormattedMessage id='taxable_benefits.help_text.taxable_on_payout.no' values={{no: <b>{t('No')}</b>}}/>
          ]}
        />
      </FormLayout>
    </div>
  );
});

export default TaxableOnPayoutForm;
